import { Box }                        from '@chakra-ui/react';
import { Text }                       from '@chakra-ui/react';
import { useTranslation }             from 'react-i18next';
import useTranslations                from '@/hooks/useTranslations';
import TransfersListBox               from '@/pages/Transfers/components/TransfersListBox';
import { ModalData }                  from '@/components/modal/Modal';
import React                          from 'react';

interface ITransfersContainerProps {
	setModalData: React.Dispatch<React.SetStateAction<ModalData | undefined>>;
	setModalIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const TransfersContainer = (props: ITransfersContainerProps) => {

	const { setModalData, setModalIsOpen } = props;
	const { t } = useTranslation();
	const { getNavigationTranslation } = useTranslations();

	const [transfersTotal, setTransfersTotal] = React.useState(0);
	
	return (
		<Box marginTop="10px">
			<Text
				className="poppins-semibold"
				fontSize="18px"
				marginBottom="20px"
			>
				<span>{t('pages.home.pendingTransfers.title')}</span>&nbsp;
				<span 
					className="poppins-light"
					style={{ 
						fontSize: '14px',
					}}
				>
						{`(${transfersTotal})`}
				</span>
			</Text>
				<TransfersListBox 
					setModalData={setModalData}
					setModalIsOpen={setModalIsOpen}
					onListSuccess={(collection) => setTransfersTotal(collection.total || collection.length)}
					options={{ 
						bottomLink: {
							label: t('pages.home.pendingTransfers.link'),
							to: getNavigationTranslation('transfers', 'path'),
						},
						status: 'waiting',
						withPagination: false,
					}}
				/>
		</Box>
	);
}

export default TransfersContainer;